import * as yup from 'yup';

import { type QtiQuestionDTO } from '@/src/lib';
import { type Option } from '@/src/utils';

export const QUANTITY_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => ({
    id: num,
    name: (num + 1).toString(),
}));

export type QuestionGenerationDTO = QtiQuestionDTO & {
    variantsForRegeneration: QuestionVariant[];
    standards: number[];
};

export type QuestionTypeOption = {
    id: number;
    name?: string;
    gradeLevelId: number;
    standards: string[];
    standardIds?: number[];
    variants: QuestionVariant[];
};
export type QuestionVariant = {
    gradeLevelId: number;
    questionTypeId: number;
    variantId: number;
    name: string;
};

export type RequestParams = {
    variants: QuestionVariant[];
    standards: number[];
};

export type QuestionAndIdDTO = {
    uuid: string;
    question: QtiQuestionDTO;
};

export type ConfigSet = {
    standardOptionId: number;
    variantIds: number[];
    quantity: number;
};

export type DynamicQuizFormValues = {
    intendedGrades: number[];
    title: string;
    standardGrades: number[];
    config: ConfigSet[];
};

export type FilterOptions = {
    gradeLevelMasterOptions: Option[];
    standardOptions: Option[];
};

const configSchema = yup.object().shape({
    standardOptionId: yup.number().required().min(1, 'Please select a standard'),
    variantIds: yup
        .array()
        .of(yup.number().required())
        .min(1, 'Please select at least one variant')
        .required('Variants are required'),
    quantity: yup.number().required(),
});
export const schema = yup.object().shape({
    intendedGrades: yup.array().of(yup.number().required()).optional(),
    title: yup.string().optional(),
    standardGrades: yup
        .array()
        .of(yup.number().required())
        .min(1, 'Please select at least one standard grade')
        .required(),
    config: yup
        .array()
        .of(configSchema)
        .min(1, 'At least one config set is required')
        .max(5, 'Maximum of 5 config sets allowed')
        .required(),
});
